// extracted by mini-css-extract-plugin
export default {"demoMenu":"demoMenu_demoMenu__7ER-m","buttonContainer":"demoMenu_buttonContainer__Yroe3","statusContainer":"demoMenu_statusContainer__p4Go6"};